exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/subscription-packages/subscription-info/subscription-info.component.css
// module id = ../../../../../src/app/core-modules/subscription-packages/subscription-info/subscription-info.component.css
// module chunks = main